<template>
  <form @submit.prevent="createRole">
    <!-- role name -->
    <div class="form-group">
      <label for="roleName">Name</label>
      <input
        type="text"
        v-model="role.name"
        class="form-control"
        id="roleName"
        aria-describedby="roleName"
      />
    </div>
    <div class="form-group">
      <label for="rolePermission">Permission</label>
      <v-select
        label="name"
        :options="permissions"
        v-model="role.permissions"
        taggable
        multiple
        :reduce="permission => permission.id"
      ></v-select>
    </div>
    <button class="btn btn--secondary" :disabled="isSubmitting">Save</button>
  </form>
</template>

<script>
const roleObj = {
  name: '',
  permissions: [],
  guard_name: 'api',
}
export default {
  props: {
    permissions: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data() {
    return {
      isSubmitting: false,
      role: {...roleObj}
    }
  },
  methods: {
    async createRole() {
      this.isSubmitting = true
      try {
        await this.$repos.userManagementRepo.createRole(this.role);
        this.$emit('updateRolesTable')
        $('#rolesModal').modal('hide')
        this.role = {...roleObj}
        this.showSuccessNotification('Role created successfully');
      }catch(error) {
        console.log(error)
        this.showErrorNotification('Error creating role');
      }finally {
        this.isSubmitting = false
      }
    }
  },
}
</script>